import { TPlaceType } from '../../types/newbuildingCallback';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewbuildingCallActionTypes {
  OpenCallbackPopup = 'newbuildingCall/openCallbackPopup',
  CloseCallbackPopup = 'newbuildingCall/closeCallbackPopup',
  SetNewbuildingCallValuationOpen = 'newbuildingCall/setCallValuationOpen',
  SetOfferIdForCallback = 'newbuildingCall/setOfferIdForCallback',
}

export type TOpenCallbackPopup = ITypedReduxAction<ENewbuildingCallActionTypes.OpenCallbackPopup, TPlaceType>;
export const openCallbackPopup = actionGenerator<ENewbuildingCallActionTypes.OpenCallbackPopup, TPlaceType>(
  ENewbuildingCallActionTypes.OpenCallbackPopup,
);

export type TCloseCallbackPopup = ITypedReduxAction<ENewbuildingCallActionTypes.CloseCallbackPopup>;
export const closeCallbackPopup = actionGenerator<ENewbuildingCallActionTypes.CloseCallbackPopup>(
  ENewbuildingCallActionTypes.CloseCallbackPopup,
);

export type TSetNewbuildingCallValuationOpen = ITypedReduxAction<
  ENewbuildingCallActionTypes.SetNewbuildingCallValuationOpen,
  boolean
>;
export const setNewbuildingCallValuationOpen = actionGenerator<
  ENewbuildingCallActionTypes.SetNewbuildingCallValuationOpen,
  boolean
>(ENewbuildingCallActionTypes.SetNewbuildingCallValuationOpen);

export type TSetOfferIdForCallback = ITypedReduxAction<
  ENewbuildingCallActionTypes.SetOfferIdForCallback,
  number | null
>;
export const setOfferIdForCallback = actionGenerator<ENewbuildingCallActionTypes.SetOfferIdForCallback, number | null>(
  ENewbuildingCallActionTypes.SetOfferIdForCallback,
);

export type TNewbuildingCallbackActions =
  | TCloseCallbackPopup
  | TOpenCallbackPopup
  | TSetNewbuildingCallValuationOpen
  | TSetOfferIdForCallback;
